/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import salesActions from "../../../../Sales/Management/redux/actions";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import { getRequest } from '../../../../../helpers/axiosClient';
import customStyles from "../../../../../assets/styles/customStyles";
import DateIcon from "../../Icons/Date";
import { emptyValidation } from "../../../../../helpers/validation";
import { SelectedIcon, UnSelectedIcon } from "../../Icons/selectedIcon";
import moment from 'moment';
import { Button, Box, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@mui/material";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';


export const SalesPaymentStatement = (props) => {
    const { visible, onSalesPaymentVisible, title, onMenuTitle } = props;
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const [reportOpen, setReportOpen] = useState(false);
    const [filterValues, setFilterValues] = useState({
        reportType: 'summary',
        startDate: new Date(),
        endDate: new Date(),
        sort: 'salesType'
    });
    const [paymentData, setPaymentData] = useState([]);
    const [errorDateFilter, setErrorDateFilter] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const saleTypes = [
        { "id": "OTHER SALES", "label": "Other Sales (Sales Bill + Sales order)" },
        { "id": "STORE SALES INVOICE", "label": "Store Sales Invoice" }
    ];

    useEffect(() => {
        if (visible) {
            customerApi();
        }
    }, [visible])


    const leaderBoardTitle = (value) => {
        switch (value) {
            case "today": return 'Today';
            case "last_7": return 'Last 7 days';
            case "last_14": return 'Last 14 days';
            case "last_20": return 'Last 20 days';
            case "custom": return `From ${moment(filterValues?.startDate).format("DD/MM/YYYY")} To ${moment(filterValues?.endDate).format("DD/MM/YYYY")}`;
            default: return '';
        }
    }

    const leaderSubBoardTitle = (filterValues) => {
        if (filterValues?.sort === 'salesType' && filterValues?.salesType) {
            return `- Sales Type: ${filterValues?.salesType === 'STORE SALES INVOICE' ? 'Store Sales' : 'Other Sales (Sales Bill + Sales order)'}`;
        } else if (filterValues?.sort === 'customer' && filterValues?.customer && filterValues?.customer?.name) {
            return `- Customer: ${filterValues?.customer?.name}`;
        }
    }

    const salesPaymentFilter = (e) => {
        e.preventDefault();
        let emptyDateFilter = emptyValidation('Date Filter', filterValues?.dateFilter, 'dropDown');
        // let emptyProductAnalysisValue = emptyValidation('Product Analysis', productAnalysisValue, 'dropDown');

        if (emptyDateFilter.isValid) {
            setLoading(true);
            try {
                let url = `?reportType=${filterValues?.reportType}`;

                if (filterValues?.sort === 'salesType' && filterValues?.salesType) {
                    url += `&type=${filterValues?.salesType}`;
                } else if (filterValues?.sort === 'customer' && filterValues?.customer && filterValues?.customer?.id) {
                    url += `${url === '' ? '?' : '&'}customerId=${filterValues?.customer?.id}`;
                }
                if (filterValues?.dateFilter) {
                    const prefix = url === '' ? '?' : '&';
                    const today = moment().format("YYYY-MM-DD");

                    const getLastDays = (days) => {
                        return moment().subtract(days - 1, 'days').format("YYYY-MM-DD");
                    };

                    switch (filterValues.dateFilter) {
                        case 'today':
                            url += `${prefix}startDate=${today}&endDate=${today}`;
                            break;

                        case 'last_7':
                            url += `${prefix}startDate=${getLastDays(7)}&endDate=${today}`;
                            break;

                        case 'last_14':
                            url += `${prefix}startDate=${getLastDays(14)}&endDate=${today}`;
                            break;

                        case 'last_20':
                            url += `${prefix}startDate=${getLastDays(20)}&endDate=${today}`;
                            break;

                        case 'custom':
                            url += `${prefix}startDate=${moment(filterValues?.startDate).format("YYYY-MM-DD")}&endDate=${moment(filterValues?.endDate).format("YYYY-MM-DD")}`;
                            break;

                        default:
                            break;
                    }
                }

                let response = getRequest(`${process.env.REACT_APP_API_URL}/paymentStatements${url}`);
                response.then(payload => {
                    setPaymentData(payload.data);
                    setReportOpen(true);
                    setLoading(false);
                }).catch(error => {
                    // Handle any errors
                    setLoading(false);
                })
            } catch (error) {
                setLoading(false);
            }
        } else {
            if (emptyDateFilter.errors !== '') {
                setErrorDateFilter(emptyDateFilter.errors);
            }
        }
    }

    const customerApi = (search = '', id = '') => {
        let filter = { or: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const handleClose = () => {
        onMenuTitle('');
        onSalesPaymentVisible(false);
        setFilterValues({
            startDate: new Date(),
            endDate: new Date(),
            sort: 'salesType'
        });
        setErrorDateFilter('');
    }

    const classes = customStyles();

    const changeHandler = (e, name = '') => {
        setFilterValues({
            ...filterValues,
            [name]: e
        });
    }

    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => salesPaymentFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <FormControl
                                tabIndex={-1}
                                className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.customIdentityRadioButton)}
                                variant={'standard'}
                                fullWidth
                                style={{ paddingLeft: 5 }}>
                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Report Type</FormLabel>
                                <RadioGroup
                                    row
                                    defaultValue={"reportType"}
                                    value={filterValues?.reportType}
                                    onChange={(e) => changeHandler(e.target.value, 'reportType')}>
                                    <FormControlLabel value="summary" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Payment" />
                                    <FormControlLabel value="details" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Sales" />
                                </RadioGroup>
                            </FormControl>
                            <AutoCompleteComponent
                                name={["Date Filter ", <span key="Date Filter" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'Date Filter' }]}
                                details={[{ "id": "today", "label": "Today" }, { "id": "last_7", "label": "Last 7 Days" }, { "id": "last_14", "label": "Last 14 Days" }, { "id": "last_20", "label": "Last 20 Days" }, { "id": "custom", "label": "Custom" }]}
                                parentValue={customObject([{ "id": "today", "label": "Today" }, { "id": "last_7", "label": "Last 7 Days" }, { "id": "last_14", "label": "Last 14 Days" }, { "id": "last_20", "label": "Last 20 Days" }, { "id": "custom", "label": "Custom" }], filterValues?.dateFilter)}
                                onChange={(data) => changeHandler(data.id, 'dateFilter')}
                                position={'bottom'}
                                id={idNamingConversion('Date Filter', 'salesPaymentStatement', 'DropDown')}
                                parentError={errorDateFilter}
                                customClasses={classes.margin20t}
                            />
                            {
                                filterValues?.dateFilter === 'custom' ? <>
                                    <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={filterValues?.startDate}
                                                format='dd/MM/yyyy'
                                                label="Start Date"
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('Start Date', 'salesPaymentStatement', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                // readOnly={true}
                                                onChange={(newValue) => {
                                                    (newValue === null || newValue === 'Invalid Date') ?
                                                        changeHandler(new Date(), 'startDate') : changeHandler(newValue, 'startDate')
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={filterValues?.endDate}
                                                format='dd/MM/yyyy'
                                                label="End Date"
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('End Date', 'salesPaymentStatement', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                // readOnly={true}
                                                onChange={(newValue) => {
                                                    (newValue === null || newValue === 'Invalid Date') ?
                                                        changeHandler(new Date(), 'endDate') : changeHandler(newValue, 'endDate')
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </> : null
                            }
                            <FormControl
                                tabIndex={-1}
                                className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton, classes.customIdentityRadioButton)}
                                variant={'standard'}
                                fullWidth
                                style={{ paddingLeft: 5 }}>
                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Filter Type</FormLabel>
                                <RadioGroup
                                    row
                                    defaultValue={"salesType"}
                                    value={filterValues?.sort}
                                    onChange={(e) => changeHandler(e.target.value, 'sort')}>
                                    <FormControlLabel value="salesType" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="By Sales Type" />
                                    <FormControlLabel value="customer" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="By Customer" />
                                </RadioGroup>
                            </FormControl>
                            {
                                filterValues?.sort === 'salesType' ? <AutoCompleteComponent
                                    name={["Sales Type"]}
                                    heads={[{ 'key': 'label', 'name': 'Sales Type' }]}
                                    details={saleTypes}
                                    parentValue={customObject(saleTypes, filterValues?.salesType)}
                                    onChange={(data) => changeHandler(data.id, 'salesType')}
                                    position={'bottom'}
                                    id={idNamingConversion('Sales Type', 'salesPaymentStatement', 'DropDown')}
                                    customClasses={classes.margin30t}
                                /> : <AutoCompleteComponent
                                    name={["Customer Name "]}
                                    heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                    { 'key': 'mobile', 'name': 'Phone Number' },
                                    { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                    details={customerDetails}
                                    id={idNamingConversion('Customer Name', 'salesPaymentStatement', 'DropDown')}
                                    parentValue={customObject(customerDetails, filterValues?.customer?.id)}
                                    onChange={(data) => changeHandler(data, 'customer')}
                                    searchType={(s) => customerApi(s)}
                                    position={"bottom"}
                                    customClasses={classes.margin30t}
                                />
                            }
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title}</h4>
                            <p className={classes.downloadsHeading}>{leaderBoardTitle(filterValues?.dateFilter)} {leaderSubBoardTitle(filterValues)}</p>

                        </div>
                        {
                            filterValues?.reportType === 'details' ? <>
                                <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                                    <Col span={4}><h6>Date</h6></Col>
                                    <Col span={7}><h6>Reference</h6></Col>
                                    <Col span={6}><h6 >Amount</h6></Col>
                                    <Col span={7}><h6 className={classes.textAlignRight}>Type</h6></Col>
                                </Row>
                                {
                                    paymentData.length > 0 ? paymentData.map((item, i) => (
                                        <Row key={i} className={clsx(classes.bill, 'no-break')}>
                                            <Col span={4}><p>{moment(item?.salesInvoice?.selfBill?.transactionDate || item?.salesInvoice?.storeSales?.transactionDate).format('DD MMM YYYY')}</p></Col>
                                            <Col span={7}><p>{item?.salesInvoice?.selfBill?.serialNo || item?.salesInvoice?.storeSales?.cashReceiptNumber}</p></Col>
                                            <Col span={6}><p>{`₹ ${currencyFormat(item?.amount)}`}</p></Col>
                                            <Col span={7} className={classes.textAlignRight}><p>{item?.type}</p></Col>
                                        </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                                {
                                    paymentData.length > 0 ? <Row className={clsx(classes.bill, 'no-break')}>
                                        <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total</h6></Col>
                                        <Col span={7} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}></p></Col>
                                        <Col span={6}><p style={{ padding: "0 5px" }}>₹ {currencyFormat(paymentData.reduce((n, { amount }) => n + amount, 0))}</p></Col>
                                        <Col span={7}><p style={{ padding: "0 5px" }}></p></Col>
                                    </Row> : null
                                }
                            </> : <>
                                <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                                    <Col span={4}><h6>Payment Type</h6></Col>
                                    <Col span={5}><h6 className={classes.textAlignRight}>Invoices Issued</h6></Col>
                                    <Col span={4}><h6 className={classes.textAlignRight}>Payments Received</h6></Col>
                                    <Col span={4}><h6 className={classes.textAlignRight}>Sales Return</h6></Col>
                                    <Col span={4}><h6 className={classes.textAlignRight}>Payment Reversal</h6></Col>
                                    <Col span={3} ><h6 className={classes.textAlignRight}>Variance</h6></Col>
                                </Row>
                                {
                                    paymentData.length > 0 ? paymentData.map((data, i) => (
                                        <Row key={i} className={clsx(classes.bill, 'no-break')}>
                                            <Col span={4}><p>{data.name}</p></Col>
                                            <Col span={5} className={classes.textAlignRight}><p>₹ {currencyFormat(data.invoice)}</p></Col>
                                            <Col span={4} className={classes.textAlignRight}><p>₹ {currencyFormat(data.payment)}</p></Col>
                                            <Col span={4} className={classes.textAlignRight}><p>₹ {currencyFormat(data.salesReturn)}</p></Col>
                                            <Col span={4} className={classes.textAlignRight}><p>₹ {currencyFormat(data.reversal)}</p></Col>
                                            <Col span={3} className={classes.textAlignRight}><p>{`₹ ${currencyFormat(data.invoice - data.salesReturn - data.payment + data.reversal)}`}</p></Col>
                                        </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                                {
                                    paymentData.length > 0 ? <Row className={clsx(classes.bill, 'no-break')}>
                                        <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total</h6></Col>
                                        <Col span={5} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}>₹ {currencyFormat(paymentData.reduce((n, { invoice }) => n + invoice, 0))}</p></Col>
                                        <Col span={4} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}>₹ {currencyFormat(paymentData.reduce((n, { payment }) => n + payment, 0))}</p></Col>
                                        <Col span={4} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}>₹ {currencyFormat(paymentData.reduce((n, { salesReturn }) => n + salesReturn, 0))}</p></Col>
                                        <Col span={4} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}>₹ {currencyFormat(paymentData.reduce((n, { reversal }) => n + reversal, 0))}</p></Col>
                                        <Col span={3} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}>₹ {currencyFormat(paymentData.reduce((n, { invoice, payment, salesReturn, reversal }) => n + (invoice - salesReturn - payment + reversal), 0))}</p></Col>
                                    </Row> : null
                                }
                            </>
                        }

                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); }}
            />
        </>
    )
}